<script>
import { authComputed } from '@state/helpers'
import UniversalSearch from "@components/autocomplete/universal-search.vue"
import store from '@state/store'

export default {

  components: {
    UniversalSearch
  },
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    isMenuOpened: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      admin: store.getters['auth/hasCollectionAdminCapabilities'],
      executive: store.getters['auth/hasCollectionExecutiveCapabilities'],
    }
  },
  computed: {
    ...authComputed,
    userChoice() {
    return this.$store.state.userChoice
    },
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu()
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar()
    },
    setUserChoice(choice) {
      this.$store.commit('setUserChoice', choice)
      sessionStorage.setItem('userChoice', choice);

    }, 
  },
}
</script>

<template>
  <!-- Topbar Start -->
  <div class="navbar navbar-expand flex-column flex-md-row navbar-custom">
    <div class="container-fluid">
      <!-- LOGO -->
      <a href="/" class="navbar-brand mr-0 mr-md-2 logo">
        <img src="@assets/images/logo.png" alt height="65" />
      </a>

      <ul class="navbar-nav bd-navbar-nav flex-row list-unstyled menu-left mb-0">
        <li class>
          <button
            class="button-menu-mobile open-left disable-btn"
            :class="{ open: isMenuOpened }"
            @click="toggleMenu"
          >
            <feather type="menu" class="menu-icon align-middle"></feather>
            <feather type="x" class="close-icon"></feather>
          </button>
        </li>
      </ul>

      <ul class="navbar-nav flex-row ml-auto d-flex list-unstyled topnav-menu float-right mb-0">

        <li v-if="admin || executive">
          <router-link
            to="/"
            :class="['btn', 'mx-2', 'btn-primary border-dark', { 'btn-inactive border-0': userChoice !== $administrative }]"
            @click.native="setUserChoice($administrative)"
          >
            Administrativo
          </router-link>
        </li>

        <li v-if="admin || executive">
          <router-link
            to="/"
            :class="['btn', 'mx-2', 'btn-primary border-dark', { 'btn-inactive border-0': userChoice !== $prejudicial }]"
            @click.native="setUserChoice($prejudicial)"
          >
            Prejudicial
          </router-link>
        </li>

        <li>
          <b-button  v-b-modal="'universal-search-modal'" class="mx-5" variant="info">
            Buscar
            <b-icon icon="search"></b-icon>
          </b-button>
        </li>

      </ul>

      <ul class="navbar-nav flex-row ml-auto d-flex list-unstyled topnav-menu float-right mb-0">
        <b-nav-item-dropdown
          right
          class="notification-list align-self-center profile-dropdown"
          toggle-class="nav-user mr-0"
        >
          <template v-slot:button-content>
            <div class="media user-profile">
              <div class="media-body text-left">
                <h6 class="pro-user-name ml-2 my-0">
                  <span>{{ user.data.name }}</span>
                  <span class="pro-user-desc text-muted d-block mt-1">{{ user.data.email }}</span>
                </h6>
              </div>
              <feather type="chevron-down" class="ml-2 align-self-center"></feather>
            </div>
          </template>
          <b-dropdown-divider></b-dropdown-divider>

          <b-dropdown-item href="/logout" class="notify-item p-0">
            <feather type="log-out" class="icon-dual icon-xs mr-2"></feather>
            <span>Logout</span>
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </ul>
    </div>
    <b-modal id="universal-search-modal" title="Buscador Universal" hide-footer>
      <UniversalSearch />
    </b-modal>
  </div>
  <!-- end Topbar -->
</template>

<style lang="scss">
.noti-scroll {
  height: 220px;
}
.ps > .ps__scrollbar-y-rail {
  width: 8px !important;
  background-color: transparent !important;
}
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
  width: 6px !important;
}
.button-menu-mobile {
  outline: none !important;
}
</style>
